export default {
  accepted_message: "베팅이 승인되었습니다.",
  waiting_message: "베팅이 대기 중입니다.",
  login: "계속하려면 로그인해 주세요...",
  password_rule: "비밀번호는 대소문자를 구분하며 6~10자로 입력해야 합니다.",
  nickname_rule: "표시 및 로그인에 사용할 닉네임을 영문 또는 숫자 6~15자로 설정할 수 있습니다. 닉네임은 한 번만 설정할 수 있으며, 설정 후에는 변경하거나 취소할 수 없습니다.",
  change_password_succeed: "비밀번호가 성공적으로 변경되었습니다.",
  add_secondary_succeed: "닉네임이 성공적으로 설정되었습니다.",
  succeed: "작업이 성공적으로 완료되었습니다!",
  failed: "작업을 완료하지 못했습니다!",
  no_information_available: "이용 가능한 정보가 없습니다.",
  select_display_language: "기본으로 사용할 언어를 선택해 주세요.",
  select_odds_type: "기본 배당률 표기 방식을 선택해 주세요.",
  select_page_type: "오늘 경기와 조기 마켓 페이지에 기본으로 표시할 페이지 유형을 선택해 주세요.",
  select_show_score_map: "베팅할 때 스코어 맵이 자동으로 표시되도록 설정합니다.",
  select_default_event_sorting: "기본 경기 정렬 방식을 선택해 주세요.",
  select_market_type: "선호하는 마켓을 선택해 주세요.",
  select_page_size: "페이지당 표시 개수를 선택해 주세요.",
  change_sports_menu_order: "스포츠 종목을 드래그하여 메뉴 순서를 변경해 주세요.",
  view_outstanding_bets_in_bet_list: "미결 베팅을 처리하는 데 시간이 걸릴 수 있습니다. 최신 미결 베팅은 베팅 목록에서 확인해 주세요.",
  time_display_in_gmt_plus_8: "위 시간은 GMT+8 기준으로 표시됩니다.",
  select_default_stake: "사용자 지정 베팅 금액과 직전 베팅 금액이 자동으로 입력되도록 설정합니다.",
  bet_empty: "베팅 슬립이 비어 있습니다. 표에 표시된 배당률을 클릭하여 베팅 항목을 선택해 주세요.",
  no_event: "현재 이용 가능한 경기 또는 게임이 없습니다. 다른 스포츠나 게임을 이용하거나 나중에 다시 방문해 주세요.",
  no_games_available: "이용 가능한 게임이 없습니다.",
  no_bets: "진행 중인 베팅이 없습니다",
  no_waiting: "대기 중인 베팅이 없습니다",
  no_void: "무효 처리된 베팅이 없습니다",
  odds_changed: "배당률 변경:",
  confirmation: "이 베팅을 진행하시겠습니까?",
  olderversion: "이전 버전이 감지되었습니다. 확인을 눌러 업데이트하거나 Ctrl-F5를 눌러 주세요.",
  gmt8: "위 시간은 GMT+8 기준으로 표시됩니다.",
  no_betting_market: "이용 가능한 베팅 마켓이 없습니다",
  note_1: "미결 베팅을 처리하는 데 시간이 걸릴 수 있습니다. 최신 미결 베팅은 내 베팅에서 확인해 주세요.",
  match_not_started: "경기가 시작되지 않았습니다",

  banner1a: "스포츠를 선택하세요",
  banner1b: "경기에 참여하세요",
  banner1c: "90개 이상의 스포츠 종목과 수천 개의 라이브 경기에서 짜릿한 베팅을 즐겨보세요. 최고의 배당률과 엄선된 스포츠 추천으로 당첨 기회를 놓치지 마세요.",
  banner2a: "주사위를 굴려보세요",
  banner2b: "잭팟에 도전하세요",
  banner2c: "고급스러운 라이브 카지노에서 몰입감 넘치는 게임을 즐기며 당첨의 기회를 잡아보세요. 언제 어디서든 좋아하는 카지노 게임을 플레이하고 라이브 딜러와 생생하게 소통할 수 있습니다.",
  banner3a: "최고의 게임 경험",
  banner3b: "혁신적인 경험",
  banner3c: "끝없이 펼쳐지는 다양한 게임을 지금 직접 경험해 보세요.",
  banner4a: "올림픽 게임",
  banner4b: "도쿄 2020",
  banner4c: "2020 하계 올림픽은 공식 명칭이 제32회 올림피아드 경기대회이며 도쿄 2020으로도 알려져 있습니다. 2021년 7월 23일부터 8월 8일까지 도쿄에서 개최된 국제 종합 스포츠 대회입니다.",
  banner4d: "유로컵 2020을 다시 만나보세요!",
  banner5a: "라이브 스포츠 및 경기 하이라이트",
  banner5aa: "실시간으로 커뮤니티와 소통하세요",
  banner5b: "웹과 모바일에서 최고의 무료 라이브 TV와 하이라이트를 시청하세요",
  banner5c: "언제 어디서나 최신 스포츠 점수를 확인하세요",

  banner6a: "e파이팅",
  banner6b: "최고의 격투 게임을 즐겨보세요",
  banner6c: "좋아하는 캐릭터를 모아 치열한 전투를 펼치고 전장의 짜릿함을 느껴보세요! 플레이할수록 더 많은 승리의 기회가 찾아옵니다!",

  banner7a: "새로운 e스포츠 인터페이스",
  banner7b: "완전히 새로운 경험",
  banner7c: "폭넓은 e스포츠 마켓과 업계를 선도하는 베팅 경험을 제공합니다.",
  banner7d: "인기 대규모 멀티플레이 게임, 경쟁력 있는 배당률과 빠른 정산을 경험하세요.",

  banner8a: "가상 게임",
  banner8b: "게임을 즐기며 색다른 승리를 경험하세요.",
  banner8c: "완전히 새로운 차원의 승리를 경험하세요.",
  banner8d: "경쟁 게임부터 격투 게임까지 다양한 장르에 몰입하고, 오랫동안 즐길 수 있는 새로운 게임을 만나보세요.",

  bannersb: "국내외의 다양한 스포츠 경기에 베팅하며 끊임없는 짜릿함과 즐거움을 만끽하세요. 언제나 최고의 배당률을 제공합니다.",
  bannersl: "현실에서 잠시 벗어나 생생하게 구현된 가상 게임의 환상적인 세계를 직접 경험해 보세요. 빠져들 수밖에 없는 재미가 기다립니다.",
  bannerlc: "특별한 라이브 카지노에 입장하여 클래식 카지노 게임과 매력적인 라이브 딜러가 선사하는 생생한 상호작용을 즐겨보세요.",

  banner10a: "즐거운 시간 보내시길 바랍니다",
  banner10b: "힘찬 북소리에 맞춰 노를 저어보세요!",

  banner11a: "FIFA 카타르 월드컵 2022, 세계 최대 국가대표팀 토너먼트",
  banner11b: "2022 월드컵은 2022년 11월 20일부터 12월 18일까지 카타르에서 개최되었습니다.",
  banner11c: "개최국 카타르를 포함한 총 32개 팀이 참가했으며, 축구 최대 축제가 중동에서 열린 최초의 월드컵입니다.",

  banner13a: "하나의 팀, 하나의 꿈, 축구 토너먼트 우승을 향해",
  banner13b: "도시 곳곳의 팀들이 연례 축구 토너먼트에서 실력과 전략, 열정을 겨루는 최고의 무대를 준비하세요. 박진감 넘치는 경기와 토너먼트 라운드에서는 어떤 결과도 일어날 수 있습니다. 함께 아름다운 축구의 짜릿함을 경험해 보세요!",

  banner15a: "찬란하고 행복한 축제가 되길 바랍니다",
  banner15b: "2023 송끄란 축제를 축하합니다",
  banner15c: "과거의 승패보다 중요한 것은 포기하지 않고 계속 나아가는 것입니다. WBET이 여러분과 사랑하는 가족에게 찬란하고 행복한 2023 송끄란 축제가 되기를 기원합니다. 사와디 삐 마이!",

  banner16a: "여러분과 가족 모두 축복 가득한 하리라야 푸아사를 보내시길 바랍니다!",
  // banner16b: "2023 송끄란 축제를 축하합니다",

  join_us1: "이곳을 당신의 세상으로 만드세요",
  join_us2: "연중무휴로 이어지는 게임과 다채로운 베팅 상품으로 다양한 취향을 만족시켜 드립니다. 풍성한 보너스와 지속적인 프로모션, 신속한 지급으로 최상의 게임 경험을 제공합니다. 지금 무료로 간편하게 가입하고 첫걸음을 시작하세요.",
  join_us3: "지금 가입하세요",

  icon1a: "모바일 최적화",
  icon1b: "다양한 모바일 플랫폼을 지원하므로 좋아하는 기기에서 언제 어디서나 게임을 즐길 수 있습니다.",
  icon2a: "강력한 보안 및 지원",
  icon2b: "개인정보와 개인 데이터를 보호하는 안전한 웹사이트에서 안심하고 게임과 거래를 이용하세요.",
  icon3a: "몰입감 넘치는 경험",
  icon3b: "직관적이고 상호작용이 뛰어난 프리미엄 게임을 엄선하여 원하는 짜릿함을 선사합니다.",
  icon4a: "고객지원",
  icon4b: "고객 만족을 최우선으로 생각합니다. 더 나은 서비스를 위한 의견이나 문의 사항을 언제든지 알려주세요.",

  footer1a: "미성년자 도박 금지",
  footer1b: "만 18세 미만의 도박은 불법이며 모든 지역에서 미성년자의 도박을 금지합니다. {fvalue}은(는) 무작위로 연령 확인을 실시하며 이용자가 만 18세 미만인 경우 당첨금이 몰수됩니다. © 2004-2019. {fvalue}은(는) 국제 등록 상표이자 허가받은 스포츠북 운영사입니다. 모든 권리 보유.",

  contactus_title1: "고객지원 담당자가 결제 관련 문의를 포함한 모든 질문에 영어와 중국어로 답변해 드립니다.",
  contactus_title2: "국제전화 요금이 부과될 수 있습니다. 고객 보호, 정보 확인, 품질 관리 및 규정 준수를 위해 통화 내용이 녹음될 수 있습니다.",

  days: "일",
  hours: "시간",
  mins: "분",
  secs: "초",
  ldiff_changed: "퍼센트가 변경되었습니다",
  no_room: "이용 가능한 룸이 없습니다. 다른 옵션을 선택하여 다시 검색하거나 나중에 다시 방문해 주세요.",
  people_in_this_room: "이 룸의 참가자",
  room_full: "룸 정원이 가득 찼습니다",
  room_joined: "이 룸에 참가했습니다",
  my_room: "내 룸",
  pin_code: "예: 123456",
  no_matches: "현재 이용 가능한 경기 또는 게임이 없습니다.",
  are_you_sure: "이 작업을 계속 진행하시겠습니까?",
  accept_terms: "체크하면 위 이용약관을 읽고 이해했으며 이에 동의함을 확인하는 것입니다.",
  accept_required: "계속하기 전에 위 이용약관을 읽고 이해한 후<br />동의해 주세요.",
  must_accept_better_odds: "기본적으로 베팅 시 더 유리한 배당률을 자동으로 적용합니다. 자세한 내용은 이용약관을 확인해 주세요.",
  maintenance_notice: "현재 시스템 점검 중입니다. 잠시 후 다시 시도해 주세요.",
  not_winning_prize_in_this_tournament: "이 토너먼트에서 상금을 획득하지 못했습니다",
  you_did_not_join_this_room: "이 룸에 참가하지 않았습니다",
  deduct_confirm: "게임이 시작되며 보유 크레딧이 차감됩니다.<br />계속하시겠습니까?",
  over_max_match: "이 리그의 경기 수가 선택 가능한 최대 경기 수를 초과했습니다.<br />리그를 펼친 후 원하는 경기를 선택해 주세요.",

  //tournament
  button_skip: "둘러보기 건너뛰기",
  button_previous: "이전",
  button_next: "다음",
  button_stop: "완료",
  button_continue: "계속",
  tour_content_1: "<h6>WBET 토너먼트에 오신 것을 환영합니다</h6><p>사이트 회원만을 위한 새롭고 흥미로운 토너먼트를 소개합니다.</p>",
  tour_content_2: "<h6>공개 룸</h6><p>회원들이 참가비를 내고 서로 경쟁하는 게임 룸입니다.</p>",
  tour_content_3: "<h6>비공개 룸</h6><p>회원이 룸을 생성하고 초대용 PIN 코드를 공유하여 친구들과 함께 게임을 즐길 수 있습니다.</p>",
  tour_content_4: "<h6>공개 무료 룸</h6><p>특별 이벤트 기간에 여러 단체가 회원 전용으로 운영하며 무료로 참가할 수 있습니다.</p>",
  tour_content_5: "<h6>참가 가능 인원 및 요금</h6><p>참가 인원: 룸의 최대 수용 인원입니다.</p><p>참가비: 룸에서 제시한 금액이며 계정 보유자의 통화가 적용됩니다.</p>",
  tour_content_6: "<h6>룸 상세 정보</h6><p>여기를 클릭하여 룸 통계를 미리 확인하고 룸에 참가할 수 있습니다.</p>",
  tour_content_7: "<h6>상금 풀 상세 정보</h6><p>우승자에게 지급되는 총 상금과 검색에 사용할 고유 룸 ID를 확인할 수 있습니다.</p>",
  tour_content_8: "<h6>룸 시작 정보</h6><p>룸 상태와 최종 참가 가능 시간이 표시됩니다.</p>",
  tour_content_9: "<h6>비공개 룸 생성</h6><p>비공개 룸을 생성하고 친구에게 입장용 PIN 코드를 공유하여 함께 게임을 즐길 수 있습니다.</p>",
  tour_content_10: "<h6>포인트 순위</h6><p>플레이어의 포인트를 표시하여 순위와 결과를 확인할 수 있습니다.</p>",

  cashoutSuccesfully: "캐시아웃이 완료되었습니다",

  time_machine_information_HDP: "WBET 타임머신 [HDP]은 선택한 시간 동안 어느 팀이 더 많은 골을 넣을지 예측하는 베팅입니다. ",
  time_machine_information_OU: "WBET 타임머신 [OU]는 선택한 시간 동안의 총 득점 수를 예측하는 베팅입니다."
};